import { csvExporter, dateCell, personName, relationField, type CsvColumn } from '../../shared/csvExport';

/**
 * Kolumny eksportu floty (ciągniki i naczepy — ten sam zasób `cars`).
 *
 * Kierowca i spółka spłaszczone do nazw: w domyślnym eksporcie były pustymi
 * kolumnami `driver` / `company`. Pola jak w `LIST_SELECT` API floty.
 */
export const FLEET_EXPORT_COLUMNS: readonly CsvColumn[] = [
  { header: 'Nr rejestracyjny', value: (r) => r.registrationNumber },
  { header: 'Nazwa', value: (r) => r.name },
  { header: 'Typ', value: (r) => r.carType },
  { header: 'Typ naczepy', value: (r) => r.trailerType },
  { header: 'Marka i model', value: (r) => r.makeAndModel },
  { header: 'Rocznik', value: (r) => r.vehicleYear },
  { header: 'Dostępny', value: (r) => r.available },
  // `vehicle_operational` z TMS — „w eksploatacji”, nie „sprawny” (08.10.2026).
  { header: 'W eksploatacji', value: (r) => r.operational },
  { header: 'Powód niedostępności', value: (r) => r.unavailableStatus },
  { header: 'Niedostępny do', value: (r) => dateCell(r.unavailableTo) },
  { header: 'Ładowność (t)', value: (r) => r.maxLoadTons },
  // Jednostka w nagłówku (poprawa brzmienia 01.10.2026) — obok kolumna w tonach.
  { header: 'Dopuszczalna ładowność (kg)', value: (r) => r.permissibleLoadCapacity },
  { header: 'Kierowca', value: (r) => personName(r.driver) },
  { header: 'Spółka', value: (r) => relationField(r.company, 'name') },
  { header: 'ID pojazdu w TMS', value: (r) => r.tmsVehicleId },
];

export const fleetExporter = csvExporter(FLEET_EXPORT_COLUMNS, 'flota');
export const trailerExporter = csvExporter(FLEET_EXPORT_COLUMNS, 'naczepy');

/**
 * Kolumny sprzed 08.10.2026 — przełącznik `operationalLabel` wyłączony
 * (wersja „obecna” = produkcja 0.31.3): ta sama kolumna z nagłówkiem
 * „Sprawny”.
 */
export const FLEET_EXPORT_COLUMNS_LEGACY: readonly CsvColumn[] = FLEET_EXPORT_COLUMNS.map((c) =>
  c.header === 'W eksploatacji' ? { ...c, header: 'Sprawny' } : c,
);

export const fleetExporterLegacy = csvExporter(FLEET_EXPORT_COLUMNS_LEGACY, 'flota');
export const trailerExporterLegacy = csvExporter(FLEET_EXPORT_COLUMNS_LEGACY, 'naczepy');
